
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Card,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';


export const ErrorComponent: React.FC<{
  errorMessage: string
}> = ( {
  errorMessage
}) => {

  const styles = ContainerClasses();

  return (
    <Box sx={styles.containerErr}>
      <Typography variant="h6">
         Error: {errorMessage}
      </Typography>
    </Box>
)
};
